export enum CvtStatus {
    RECEIVED_RESPONSE_FROM_SBR = 'RECEIVED_RESPONSE_FROM_SBR',
    CVT_FILE_UPLOADED = 'CVT_FILE_UPLOADED',
    SENT_CVT_TO_SBR = 'SENT_CVT_TO_SBR',
    UPLOAD_SUCCESS = 'UPLOAD_SUCCESS',
    CVT_FILE_UPLOADING = 'CVT_FILE_UPLOADING',
    CVT_FILE_UPLOAD_FAIL = 'CVT_FILE_UPLOAD_FAIL',
    ERROR_PROCESSING_DIAGNOSTIC_DATA = 'ERROR_PROCESSING_DIAGNOSTIC_DATA',
    SBR_PROCESS_FAILED = 'SBR_PROCESS_FAILED',
    SBR_STS_UPLOAD_FAIL = 'SBR_STS_UPLOAD_FAIL',
    SBR_UPLOAD_FAIL = 'SBR_UPLOAD_FAIL',
    STS_UPLOAD_FAIL = 'STS_UPLOAD_FAIL',
}
/** qmr-worker retries files stuck in SBR_UPLOAD_FAIL & CVT_FILE_UPLOADED every 10 minutes */
export const CVT_STATUS_MAP: Record<string, string> = {
    RECEIVED_RESPONSE_FROM_SBR: 'Completed',
    CVT_FILE_UPLOADED: 'Pending',
    SENT_CVT_TO_SBR: 'Pending',
    UPLOAD_SUCCESS: 'Pending',
    CVT_FILE_UPLOADING: 'Pending',
    CVT_FILE_UPLOAD_FAIL: 'Failed',
    ERROR_PROCESSING_DIAGNOSTIC_DATA: 'Failed',
    SBR_PROCESS_FAILED: 'Failed',
    SBR_STS_UPLOAD_FAIL: 'Failed',
    SBR_UPLOAD_FAIL: 'Pending',
    STS_UPLOAD_FAIL: 'Failed',
};

export enum CvtPresignedUrlFailType {
    SBR = 'SBR_UPLOAD_FAIL',
    STS = 'STS_UPLOAD_FAIL',
}
export interface SBRVehicleData {
    time: number;
    mark: number;
    engineSpeed: number;
    primaryRevSpeed: number;
    secondaryRevSpeed: number;
    lockUpDutyRatio: number;
    actualGearRatio: number;
    frontWheelSpeed: number;
    primaryUpDuty: number;
    luJudder: number;
    luYusa: number;
    fwdClutchSlip: number;
    chainSlip: number;
    inputClutchSlip: number;
}

export interface SBRResponseData {
    repairRecommendation: string;
    symptomDescription: string[];
    symptomTitle: string[];
    errorType?: string;
    errorDetail?: string;
    techShareRepairRecommendation?: string; // HTML Formate string
}

export type CVT = {
    accountId: string;
    accountName?: string;
    diagnosticId: string;
    fileName: string;
    jobCompletedTimestamp?: string; // ISO Date
    jobSubmittedTimestamp?: string; // ISO Date
    roNumber?: string;
    sbrResponseData: SBRResponseData;
    sbrResponse: SbrResponse;
    sbrResponseDataUrl?: string;
    stsErrorResponse?: string;
    status: CvtStatus;
    vin: string;
};

export interface GetCVTsResponse {
    results: CVT[];
    totalCount: number;
    offset: number;
    limit: number;
}

export type SbrResponse = {
    data: SBRVehicleData[];
    logicVersion: string;
    errorType?: string;
};

export type CvtSbrResponseData =
    | {
          data: SBRVehicleData[];
          misuseFlag: number;
          repairRecommendation?: string; // HTML Formate string
          sbrDiagnosticId?: string;
          symptomDescription?: string[];
          symptomTitle?: string[];
          techShareRepairRecommendation?: string; // HTML Formate string
      }
    | CvtErrorSbrResponseData;

export type CvtErrorSbrResponseData = {
    errorType: string;
    errorDetail: string;
};

export type CvtRetailerDetails = {
    name: string;
    code: string;
    region: string;
    zone: string;
    district: string;
};

export type CvtStatusData = {
    diagnosticId: string;
    sbrDiagnosticId?: string;
    vin: string;
    fileName: string;
    status: CvtStatus;
    sbrResponseData?: CvtSbrResponseData;
    sbrResponseDataUrl: string;
    accountId: string;
    accountName: string;
    jobCompletedTimestamp: string; // ISO Date
    jobSubmittedTimestamp: string; // ISO Date
    retailer: CvtRetailerDetails | null;
    stsErrorResponse?: string;
};

export type CvtPresignedUrlsUploadFailure =
    | {
          sbrFailStatus: CvtPresignedUrlFailType.SBR;
          sbrFailMessage: string;
          stsFailStatus?: never;
          stsFailMessage?: never;
      }
    | {
          sbrFailStatus?: never;
          sbrFailMessage?: never;
          stsFailStatus: CvtPresignedUrlFailType.STS;
          stsFailMessage: string;
      }
    | {
          sbrFailStatus: CvtPresignedUrlFailType.SBR;
          sbrFailMessage: string;
          stsFailStatus: CvtPresignedUrlFailType.STS;
          stsFailMessage: string;
      };

export type CvtUploadResponse = {
    sbrUploadUrl: string;
    stsUploadUrl: string;
    sbrDiagnosticId: string;
    stsDiagnosticId: string;
    message?: string;
};
